export default __webpack_public_path__ + "static/calidad-de-los-alumnos-large-1bdaf42648ae0e723afaa540ba304115.svg";